import { render, staticRenderFns } from "./PhoTextarea.vue?vue&type=template&id=685985a8&lang=pug"
import script from "./PhoTextarea.vue?vue&type=script&lang=js"
export * from "./PhoTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports